import {
  useQuery, useMutation, useQueryClient 
} from '@tanstack/react-query';
import {
  getPaymentBatches,
  approvePaymentBatch,
  processPaymentBatch,
  type PaymentBatchFilters,
} from '../api';

export function usePaymentBatches(filters?: PaymentBatchFilters) {
  return useQuery({
    queryKey: ['payment-batches', filters],
    queryFn: () => getPaymentBatches(filters),
  });
}

export function useApprovePaymentBatch() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: approvePaymentBatch,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['payment-batches'] });
    },
  });
}

export function useProcessPaymentBatch() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processPaymentBatch,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['payment-batches'] });
    },
  });
}
